import axios from "axios";
import {CARBON_LOGGER_SCOPE1} from '../../config/carbonx.links'
// import {FLEET_LIST_URL} from '../../config/links'
import {toast} from 'react-toastify'

export const FETCH_CARBON_LOGGER_SCOPE1_LIST = 'FETCH_CARBON_LOGGER_SCOPE1_LIST'
export const RECEIVE_CARBON_LOGGER_SCOPE1_LIST = 'RECEIVE_CARBON_LOGGER_SCOPE1_LIST'
export const RECEIVE_CARBON_LOGGER_SCOPE1_ALL_LIST = 'RECEIVE_CARBON_LOGGER_SCOPE1_ALL_LIST'
export const FAILED_CARBON_LOGGER_SCOPE1_LIST = 'FAILED_CARBON_LOGGER_SCOPE1_LIST'

export function fetchCarbonLoggerScope1(_data){

    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_CARBON_LOGGER_SCOPE1_LIST});
        axios({
            method: 'post',
            url: CARBON_LOGGER_SCOPE1,
            headers: {
                Authorization: auth
            },
            data: _data
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_CARBON_LOGGER_SCOPE1_LIST,
                payload: {scope1: response.data, id_fleet: _data.id_fleet}
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                })
                // return toast.error('Something went wrong... Please try again later...')
                return
            }
        })
    }
}

export function fetchCarbonLoggerScope1AllFleet(_data){
    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_CARBON_LOGGER_SCOPE1_LIST});
        axios({
            method: 'post',
            url: CARBON_LOGGER_SCOPE1,
            headers: {
                Authorization: auth
            },
            data: {start_date: _data.start_date, end_date: _data.end_date}
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_CARBON_LOGGER_SCOPE1_ALL_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export function fetchCarbonLoggerScope1AllFleetByWoId(_data){
    return (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_CARBON_LOGGER_SCOPE1_LIST});
        axios({
            method: 'post',
            url: CARBON_LOGGER_SCOPE1,
            headers: {
                Authorization: auth
            },
            data: {
                    start_date: _data.start_date, 
                    end_date: _data.end_date, 
                    id_wo: _data.id_wo
                  }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_CARBON_LOGGER_SCOPE1_ALL_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_CARBON_LOGGER_SCOPE1_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}